import {AppState, AppStateField} from '@/store/app-state';
import {GetterTree} from 'vuex';
import {User} from '@/types/user';
import {UserRole} from '@/types/user-role';

export const getters: GetterTree<AppState, AppState> = {

  /**
   * Текущий пользователь
   */
  currentUser(state: AppState): User | undefined {
    return state[AppStateField.USER] as User;
  },

  isAdmin(state: AppState): boolean {
    return (state[AppStateField.USER] as User).role == UserRole.ADMIN;
  },

  lastRequestedRoute(state: AppState) {
    return '/login'
  }
};
